import StatisticGraphics from './StatisticGraphics';

export default StatisticGraphics;